import type {GetExamsAvailableTimes} from 'domain/usecases/private/booking-flow/exams/get-exams-available-times';
import {RemoteGetExamsAvailableTimes} from 'data/usecases/private/booking-flow/exams/remote-get-exams-available-times';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import {getFeatureFlagValue} from 'infra/http/utils/get-feature-flag-value';
import {FeaturesEnum} from 'presentation/constants';

export const makeGetExamsAvailableTimes = (): GetExamsAvailableTimes => {
	const isExamsAvailabilityTimesV3Enabled = getFeatureFlagValue(
		FeaturesEnum.PORTAL_FEATURE_EXAMS_AVAILABILITY_TIMES_V3,
	);

	const endpoint = isExamsAvailabilityTimesV3Enabled
		? BookingFlowEndPoints.examTimesV3
		: BookingFlowEndPoints.examTimes;

	return new RemoteGetExamsAvailableTimes(
		makeBFFApiUrl(endpoint),
		makeAuthorizeHttpClientDecorator(),
	);
};
